import { Controller } from "stimulus"

const THINKING_MESSAGES = [
  "Thinking...",
  "Reasoning...",
  "Working on it...",
  "Considering...",
  "Processing...",
  "Reflecting...",
  "Exploring...",
  "Connecting ideas...",
  "Almost there...",
  "Still thinking...",
  "One moment...",
  "Composing...",
  "Neurons firing...",
  "Brewing something good...",
  "Hmm, let me think...",
  "On it...",
  "Give me a sec...",
  "Wheels are turning...",
  "Crunching ideas...",
  "Spinning up...",
]

export default class extends Controller {
  static targets = ["text"]

  connect() {
    this._used = new Set([0])
    this.scheduleNext()
  }

  disconnect() {
    clearTimeout(this._timeout)
  }

  scheduleNext() {
    // Random interval between 4-15 seconds
    const delay = 4000 + Math.random() * 11000
    this._timeout = setTimeout(() => {
      this.showNext()
      this.scheduleNext()
    }, delay)
  }

  showNext() {
    if (!this.hasTextTarget) return

    // Pick a random message we haven't shown recently
    let idx
    if (this._used.size >= THINKING_MESSAGES.length - 1) {
      this._used.clear()
    }
    do {
      idx = Math.floor(Math.random() * THINKING_MESSAGES.length)
    } while (this._used.has(idx))

    this._used.add(idx)
    this.textTarget.textContent = THINKING_MESSAGES[idx]
  }
}
